/** 検索を実行する最小のキーワード数 */
const KEYWORD_MIN_LENGTH = 2

/**
 * 商品の検索結果を表示する
 *
 * @param products
 * @param searchPageUrl
 */
const createElementProducts = (products, searchPageUrl) => {
	// ローダー削除
	$('.loaderWrap.product-container').hide();

	if (products['results_total'] === 0) {
		$('#product-container').empty().append(`
			<div class="no-results">
				商品が見つかりませんでした。<br>
				キーワードを変更して、再検索してください。
			</div>
		`);
	} else {
		let html = '';
		products['results'].forEach((product) => {
			const isDiscount = product['discount'] ? 'inline' : 'none';
			html += `
				<li class="suggest-item card">
					<a class="card-link cardimglink" href="${product['url']}">
						<div class="card-img"><img src="${product['thumbnail']}" alt="${product['title']}"></div>
						<p class="card-ttl">${product['title']}</p>
						<div class="card-price">
							<span class="price">${product['price']}</span>
							<span class="discount" style="display:${isDiscount}">${product['discount']}</span>
						</div>
					</a>
				</li>
			`;
		});

		$('#product-container').empty().append(`<ul class="suggest-list card-list product-container"></ul>`);
		$('.suggest-list.card-list.product-container').append(html);
		$('#product-container').append(`
			<div class="suggest_goods-all">
				<a class="suggest_goods_all-link textlink01" href='${searchPageUrl}'>${products['results_total']}個の商品すべて表示
					<figure>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path d="M5 12l14 0"></path>
							<path d="M15 16l4 -4" /><path d="M15 8l4 4" />
						</svg>
					</figure>
				</a>
			</div>
		`);
	}
}

/**
 * コレクションの検索結果を表示する
 * Shopifyの仕様上コレクションの一覧はダイレクトに検索できないので、
 * 検索結果で取得できた商品に紐づくコレクションを出現率の高い順にソートして、上位3件を表示する。
 *
 * @param products
 */
const createElementCollection = (products) => {
	// ローダー削除
	$('.loaderWrap.collection-container').hide();

	if (products['results_total'] === 0) {
		$('#collection-container').empty().append(`
			<div class="no-results">
				コレクションが見つかりませんでした。<br>
				キーワードを変更して、再検索してください。
			</div>
		`);
	} else {
		const collections = [];
		const collectionsWithCount = {};

		// コレクションの配列を作成する（重複あり）
		products['results'].forEach((product) => {
			product['collections'].forEach((collection) => collections.push(collection));
		});

		// 各コレクションの出現回数をサマリーする
		collections.forEach((collection) => {
			const handle = collection['handle'];
			if (!collectionsWithCount.hasOwnProperty(handle)) {
				Object.assign(collection, {count: 1});
				collectionsWithCount[handle] = collection;
			} else {
				collectionsWithCount[handle]['count']++
			}
		});

		// collectionsWithCountのカウントが多い順にソートし、上位3件を取得
		const sortedCollection = Object.keys(collectionsWithCount)
			.map((key) => collectionsWithCount[key])
			.sort((a, b) => {
				if (a['count'] > b['count']) return -1;
				if (a['count'] < b['count']) return 1;
				return 0;
			})
			.slice(0, 3);

		let html = '';
		sortedCollection.forEach((collection) => {
			html += `<li class="suggest-item"><a class="textlink01" href="${collection['url']}">${collection['title']}</a></li>`;
		});

		$('#collection-container').empty().append(`<ul class="suggest-list collection-container"></ul>`);
		$('.suggest-list.collection-container').append(html);
	}
}

/**
 * 関連記事の検索結果を表示する
 *
 * @param articles
 */
const createElementArticle = (articles) => {
	// ローダー削除
	$('.loaderWrap.article-container').hide();

	if (articles['results_total'] === 0) {
		$('#article-container').empty().append(`
			<div class="no-results">
				関連記事が見つかりませんでした。<br>
				キーワードを変更して、再検索してください。
			</div>
		`);
	} else {
		let html = '';
		articles['results'].forEach((article) => {
			html += `<li class="suggest-item"><a class="textlink01" href="${article['url']}">${article['title']}</a></li>`;
		});

		$('#article-container').empty().append(`<ul class="suggest-list article-container"></ul>`);
		$('.suggest-list.article-container').append(html);
	}
}

/**
 * サジェスト検索を行う
 */
const suggestSearch = () => {
	const keywordElement = $('#suggest-search-keyword');
	let searchTimeoutThrottle = 500;
	let searchTimeoutID = -1;
	let domain = window.location.protocol + '//' + window.location.host;
	let jqXHRs = [];

	keywordElement.on('change input keyup', (event) => {
		const keyword = keywordElement.val();
		const oldKeyword = keywordElement.data('oldValue');

		// 以下のパターンの場合は何もせず処理を終了する
		// ・キーワードが空の場合
		// ・前の検索ワードと同じ場合
		// ・キーワードの文字数が2文字以下の場合
		if (!keyword || keyword === oldKeyword || keyword.length < KEYWORD_MIN_LENGTH) return false;
		// 通信中のAjaxリクエストを中断
		if (jqXHRs.length > 0) jqXHRs.forEach((xhr) => xhr.abort());
		// 以前の検索を中断
		clearTimeout(searchTimeoutID);

		const headerShipping = document.querySelector(".header-shipping");
		headerShipping.style.display = "none";

		keywordElement.data('oldValue', keyword);
		let newKeyword = keyword;
		if (!newKeyword.match(/^[A-Za-z0-9!-/:-@¥[-`{-~]*$/)) {
			newKeyword = '"' + newKeyword + '"';
		}
		const searchPageUrl = `/search?q=${newKeyword}&type=product`;

		// リクエストパラメータの設定
		// dataオブジェクト内のviewプロパティが日本語サジェスト検索の肝
		// search.product-suggest.liquid,search.article-suggest.liquidの中身の形式でJSONレスポンスしてくれる（公式リファレンスに未掲載？）
		// inspired by: https://qiita.com/Shopify_ojisan/items/f3074660bb4c1b8fb2eb
		const requests = [
			{ url: domain + '/search', type: 'GET', data: { type: 'product', view: 'product-suggest', q: newKeyword }, dataType: 'json' },
			{ url: domain + '/search', type: 'GET', data: { type: 'article', view: 'article-suggest', q: newKeyword }, dataType: 'json' }
		];

		searchTimeoutID = setTimeout(function () {
			// サジェストを表示
			$('.ec_search-suggest').fadeIn(200);
			// 商品、コレクション、記事の要素を空にして、ローダーを表示
			$('#product-container').empty();
			$('#collection-container').empty();
			$('#article-container').empty();
			$('.loaderWrap.product-container').fadeIn(200);
			$('.loaderWrap.collection-container').fadeIn(200);
			$('.loaderWrap.article-container').fadeIn(200);
			bodyScrollPrevent(true);

			// リクエストを実行しPromiseを配列に格納
			$.ajax(requests[0])
				.then((pResult) => {
					return $.ajax(requests[1])
						.then((aResult) => {
							const products = pResult;
							const articles = aResult;
							jqXHRs = [];
							createElementProducts(products, searchPageUrl);
							createElementCollection(products);
							createElementArticle(articles);
							headerShipping.style.display = "none";
						})
						.catch((e) => {
							console.error(e);
							alert('記事データの取得に失敗しました。');
						});
				})
				.catch((e) => {
					console.error(e);
					alert('商品データの取得に失敗しました。');
				});
		}, searchTimeoutThrottle);
	})
	.attr('autocomplete', 'off')
	.data('oldValue', '')
	.on('focusin', () => {
		// 再フォーカスされた時にサジェストを表示
		if (keywordElement.val()
			&& keywordElement.val().length >= KEYWORD_MIN_LENGTH
			&& document.getElementById('product-container').childNodes.length !== 0
		) {
			$('.ec_search-suggest').fadeIn(200);
			bodyScrollPrevent(true);
		}
	})
	.on('click', (e) => {
		//クリックして、ボディが[イベント]をクリックしないようにする
		e.stopPropagation();
	});

	$('.ec_search-suggest').on('click', (e) => {
		//クリックして、ボディが[イベント]をクリックしないようにする
		e.stopPropagation();
	});

	//サジェストを非表示
	$('body').bind('click', () => {
		if ($('.ec_search-suggest').css('display') === 'block') {
			bodyScrollPrevent(false);
			$('.ec_search-suggest').fadeOut(200);
		}
	});

	//サジェストを非表示
	$('.searchClose').on('click', function(event) {
		if ($('.ec_search-suggest').css('display') === 'block') {
			bodyScrollPrevent(false);
			$('.ec_search-suggest').fadeOut(200);
		}
	});
}

/**
 * 検索ページへ遷移する
 */
const viewSearchPage = () => {
	const domain = window.location.protocol + '//' + window.location.host;
	let newKeyword = $('#suggest-search-keyword').val();
	if (!newKeyword.match(/^[A-Za-z0-9!-/:-@¥[-`{-~]*$/)) {
		newKeyword = '"' + newKeyword + '"';
	}
	const searchPageUrl = newKeyword ? `/search?q=${newKeyword}&type=product` : `/collections/all`;
	window.location = domain + searchPageUrl;
}

/**
 * 初期処理
 *
 * サジェスト検索を実行する準備をする。
 * 日本語テーマでは、サジェスト検索が簡単に行えるShopify標準のPredictive Searchが利用できない。
 * そのため、search画面用のリクエストを用いて、jsonを返却してもらうようにパラメータを工夫して、
 * 日本語でもサジェスト検索を行えるようにした。
 */
$(function() {
	suggestSearch();
});






